// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RoundedListItem__medium-1-size-e79d28 {
  --tall-list-item-vertical-offset: 16px;
  --tall-list-item-horizontal-offset: 16px;
}

.RoundedListItem__medium-2-size-c60b8a {
  --tall-list-item-vertical-offset: 32px;
  --tall-list-item-horizontal-offset: 16px;
}

.RoundedListItem__container-b66fd1 {
  --tall-list-item-background: transparent;
  --tall-list-item-background-hover: var(--base-20);
  --tall-list-item-background-pressed: var(--base-30);
  --tall-list-item-background-focused: var(--base-20);
  border-radius: 24px;
  display: flex;
  padding: var(--tall-list-item-horizontal-offset) var(--tall-list-item-vertical-offset);
  gap: 12px;
  align-items: center;
  width: 100%;
  text-align: start;
  background: var(--tall-list-item-background);
  cursor: pointer;
}

button.RoundedListItem__container-b66fd1 {
  cursor: pointer;
}

.RoundedListItem__container-b66fd1:hover {
  background: var(--tall-list-item-background-hover);
}

.RoundedListItem__container-b66fd1:active,
.RoundedListItem__container-b66fd1:active:hover,
.RoundedListItem__container-b66fd1:active:focus {
  background: var(--tall-list-item-background-pressed);
}

.RoundedListItem__container-b66fd1:active:disabled,
.RoundedListItem__container-b66fd1:hover:disabled,
.RoundedListItem__container-b66fd1:focus:disabled,
.RoundedListItem__container-b66fd1:disabled {
  opacity: 0.5;
  cursor: default;
  background: var(--tall-list-item-background);
}

.RoundedListItem__container-b66fd1:focus {
  background: var(--tall-list-item-background-focused);
}

.RoundedListItem__prefix-c6a84d {
  width: 48px;
  height: 48px;
}

.RoundedListItem__info-ea3381 {
  flex: 1;
}

.RoundedListItem__suffix-d8fa2d {
  color: var(--base-70);
}

.RoundedListItem__title-db4ea2 {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--base-110);
}

.RoundedListItem__subtitle-a8cddd {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/RoundedListItem/RoundedListItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,sCAAA;EACA,wCAAA;AACF;;AAEA;EACE,sCAAA;EACA,wCAAA;AACF;;AAEA;EACE,wCAAA;EACA,iDAAA;EACA,mDAAA;EACA,mDAAA;EAEA,mBAAA;EACA,aAAA;EACA,sFAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,4CAAA;EACA,eAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,kDAAA;AAAF;;AAGA;;;EAGE,oDAAA;AAAF;;AAGA;;;;EAIE,YAAA;EACA,eAAA;EACA,4CAAA;AAAF;;AAGA;EACE,oDAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,OAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;AAAF;;AAGA;EACE,4BAAA;EACA,8CAAA;EACA,qBAAA;AAAF","sourcesContent":[".medium-1-size {\n  --tall-list-item-vertical-offset: 16px;\n  --tall-list-item-horizontal-offset: 16px;\n}\n\n.medium-2-size {\n  --tall-list-item-vertical-offset: 32px;\n  --tall-list-item-horizontal-offset: 16px;\n}\n\n.container {\n  --tall-list-item-background: transparent;\n  --tall-list-item-background-hover: var(--base-20);\n  --tall-list-item-background-pressed: var(--base-30);\n  --tall-list-item-background-focused: var(--base-20);\n\n  border-radius: 24px;\n  display: flex;\n  padding:var(--tall-list-item-horizontal-offset) var(--tall-list-item-vertical-offset);\n  gap: 12px;\n  align-items: center;\n  width: 100%;\n  text-align: start;\n  background: var(--tall-list-item-background);\n  cursor: pointer;\n}\n\nbutton.container {\n  cursor: pointer;\n}\n\n.container:hover {\n  background: var(--tall-list-item-background-hover);\n}\n\n.container:active,\n.container:active:hover,\n.container:active:focus {\n  background: var(--tall-list-item-background-pressed);\n}\n\n.container:active:disabled,\n.container:hover:disabled,\n.container:focus:disabled,\n.container:disabled {\n  opacity: 0.5;\n  cursor: default;\n  background: var(--tall-list-item-background);\n}\n\n.container:focus {\n  background: var(--tall-list-item-background-focused);\n}\n\n.prefix {\n  width: 48px;\n  height: 48px;\n}\n\n.info {\n  flex: 1;\n}\n\n.suffix {\n  color: var(--base-70);\n}\n\n.title {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--base-110);\n}\n\n.subtitle {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"medium-1-size": `RoundedListItem__medium-1-size-e79d28`,
	"medium1Size": `RoundedListItem__medium-1-size-e79d28`,
	"medium-2-size": `RoundedListItem__medium-2-size-c60b8a`,
	"medium2Size": `RoundedListItem__medium-2-size-c60b8a`,
	"container": `RoundedListItem__container-b66fd1`,
	"prefix": `RoundedListItem__prefix-c6a84d`,
	"info": `RoundedListItem__info-ea3381`,
	"suffix": `RoundedListItem__suffix-d8fa2d`,
	"title": `RoundedListItem__title-db4ea2`,
	"subtitle": `RoundedListItem__subtitle-a8cddd`
};
module.exports = ___CSS_LOADER_EXPORT___;
